'use client'

import _ from 'lodash'
import { twMerge } from 'tailwind-merge'
import { useState } from 'react'
import { forwardRef } from 'react'
import { Combobox, ComboboxInput, ComboboxOptions, ComboboxOption } from '@headlessui/react'

type Props = {
  name: string
  option: number[]
  value?: string | number | null | any
  className?: string
  onChange: (val: string | any) => void
  inputMode?: 'text' | 'numeric' | 'tel' | 'email' | 'url'
} & React.ComponentPropsWithoutRef<'input'>

export const AutoComplete = forwardRef<HTMLInputElement, Props>((props: Props, ref: any) => {
  const { name, option, value, onChange, className, inputMode } = props
  const [query, setQuery] = useState('')

  const filterd =
    query === ''
      ? option
      : _.filter(option, (d) => { return _.startsWith(d.toString(), query.toString()) })

  return (
    <Combobox as='div' value={value} onChange={(val) => onChange(val)} className={className} onClose={() => setQuery('')}>
      <div className={twMerge('relative text-sm mt-1')}>
        <ComboboxInput
          name={name}
          as='input'
          className='form-listbox'
          onChange={(e) => setQuery(e.target.value)}
          ref={ref}
          autoComplete='off'
          onFocus={(e) => e.target.select()}
          type={inputMode}
          inputMode={inputMode}
        />
        <ComboboxOptions transition className='form-options'>
          {
            _.map(filterd || [], (d, idx) => {
              return (
                <ComboboxOption key={idx} value={d} className='form-option'>
                  <span className='block truncate group-data-selected:font-semibold'>{d.toString()}</span>
                </ComboboxOption>
              )
            })
          }
        </ComboboxOptions>
      </div>
    </Combobox >
  )
})

